import React from "react";
import { Link } from "react-router-dom";
import { US_STATES, stateSlug } from "@/lib/api";
import { MapPin, ArrowRight } from "lucide-react";

export default function StatesIndex() {
  return (
    <div data-testid="states-index-page" className="mx-auto max-w-5xl px-6 py-16 lg:px-8">
      <p className="text-sm uppercase tracking-[0.18em] text-primary">
        <MapPin className="mb-0.5 mr-1 inline h-3.5 w-3.5" /> Browse by state
      </p>
      <h1 className="mt-3 font-serif text-5xl text-forest leading-[1.05]">
        Adult Day Care &amp; Memory Care across all 50 states
      </h1>
      <p className="mt-4 max-w-2xl text-base text-muted-foreground">
        Pick your state to browse member homes offering drop-in care, weekly respite,
        memory care, and trial stays. Don't see your state? Call us — our network is
        growing fast and we can still help with placement.
      </p>

      <div className="mt-10 grid gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {US_STATES.map((s) => (
          <Link
            key={s.code}
            to={`/state/${stateSlug(s.name)}`}
            data-testid={`states-index-${s.code}`}
            className="group flex items-center justify-between rounded-xl border border-border/60 bg-card px-4 py-3 text-sm text-foreground transition hover:border-primary hover:text-primary hover:shadow-sm"
          >
            <span className="font-medium">{s.name}</span>
            <ArrowRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
          </Link>
        ))}
      </div>
    </div>
  );
}
